// jsconsoleのglobal_variables.js内にあった各種定数

const RATIO = 0.01 // 広告を見れる面積/視野面積の最小値
const LAT_35 = 110940 // 北緯35度付近での1緯度の整数値
const LON_35 = 91287 // 北緯35度付近での1経度の整数値
const SPAN = 5 // 通過点の間隔(m)
const SPACE = 5 // 5m間隔で点を打つ

export { RATIO, LAT_35, LON_35, SPAN, SPACE }
